const BASE = process.env.REACT_APP_API_URL || '/api';

async function request(path, options = {}) {
  const res = await fetch(`${BASE}${path}`, {
    headers: { 'Content-Type': 'application/json', ...options.headers },
    ...options
  });
  const data = await res.json();
  if (!data.success) throw new Error(data.message || 'Request failed');
  return data.data ?? data;
}

// Draft
export const getDraft = () => request('/pipeline-config/draft');
export const updateDraft = (body) => request('/pipeline-config/draft', { method: 'PUT', body: JSON.stringify(body) });
export const getDraftStages = () => request('/pipeline-config/draft/stages');

// Stage CRUD
export const createStage = (body) => request('/pipeline-config/draft/stages', { method: 'POST', body: JSON.stringify(body) });
export const updateStage = (uid, body) => request(`/pipeline-config/draft/stages/${uid}`, { method: 'PUT', body: JSON.stringify(body) });
export const deleteStage = (uid) => request(`/pipeline-config/draft/stages/${uid}`, { method: 'DELETE' });
export const reorderStages = (order) => request('/pipeline-config/draft/stages/reorder', { method: 'PUT', body: JSON.stringify({ order }) });

// Checklist
export const getChecklist = (uid) => request(`/pipeline-config/draft/stages/${uid}/checklist`);
export const updateChecklist = (uid, checklist) => request(`/pipeline-config/draft/stages/${uid}/checklist`, { method: 'PUT', body: JSON.stringify({ checklist }) });

// Versions
export const publishDraft = (body) => request('/pipeline-config/publish', { method: 'POST', body: JSON.stringify(body) });
export const getVersions = () => request('/pipeline-config/versions');
export const getVersion = (id) => request(`/pipeline-config/versions/${id}`);
export const activateVersion = (id) => request(`/pipeline-config/versions/${id}/activate`, { method: 'POST' });
export const getActiveVersion = () => request('/pipeline-config/active');
